import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { PlanCuidadoValidateContent } from './components/PlanCuidadoValidateContent';

export default function PlanCuidadoValidar() {

    return (
        <MainContent component={<PlanCuidadoValidateContent/>} titulo='Validar plan' tableMaxWidth />
    );

};